/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Space, Table, Tag, Tooltip } from "antd";
import {
  FilterOutlined,
  DeleteOutlined,
  LockOutlined,
  UnlockOutlined,
  AlertOutlined,
  CloudServerOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { estacaoRequest } from "./estacaoRequest";
import { colors } from "../../../../Utils/temas";
import { FiltrosEstacao } from "./componentes/filtros";
import { ModalDelete } from "./componentes/modalDelete";
import { ModalControle } from "../../../../Componentes/ModalControle";
import { ModalStatusControle } from "../../../../Utils/modalStatus";
import { ModalControleEstacao } from "./componentes/modalBloqueio";
import dayjs from "dayjs";

export const Estacao = ({ id, tab }) => {
  const [estacoes, setEstacoes] = useState([]);
  const [filtrosVisiveis, setFiltrosVisiveis] = useState(false);
  const [statusControle, setStatusControle] = useState(false);
  const [carregandoEstacoes, setCarregandoEstacoes] = useState(false);
  const [modalExclusaoVisivel, setModalExclusaoVisivel] = useState(false);
  const [modalAlertaLoteVisivel, setModalAlertaLoteVisivel] = useState(false);
  const [modalSucessoVisivel, setModalSucessoVisivel] = useState(false);
  const [modalBloqueioVisivel, setModalBloqueioVisivel] = useState(false);
  const [modalBloqueioLoteVisivel, setModalBloqueioLoteVisivel] =
    useState(false);
  const [processandoAlertaLote, setProcessandoAlertaLote] = useState(false);
  const [confirmandoControle, setConfirmandoControle] = useState(false);
  const [processandoBloqueioLote, setProcessandoBloqueioLote] = useState(false);
  const [modalControleAlertaVisivel, setModalControleAlertaVisivel] =
    useState(false);
  const [modalControleServidorVisivel, setModalControleServidorVisivel] =
    useState(false);
  const [estacaoSelecionadaId, setEstacaoSelecionadaId] = useState(null);
  const [totalEstacoes, setTotalEstacoes] = useState(null);
  const [filtrosEstacao, setFiltrosEstacao] = useState({});
  const [ordenacao, setOrdenacao] = useState();
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(10);
  const [mensagemSucesso, setMensagemSucesso] = useState("");

  useEffect(() => {
    if (tab === 2) {
      buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
    }
  }, [filtrosEstacao, ordenacao, tab, paginaAtual, itensPorPagina]);

  const formatarData = (data) => {
    const date = new Date(data);
    const dataFormatada = date.toLocaleString().split(",");
    return dataFormatada;
  };

  const columns = [
    {
      key: "nome_estacao",
      dataIndex: "nome_estacao",
      sorter: true,
      sortOrder:
        ordenacao === "nome_estacao"
          ? "ascend"
          : ordenacao === "-nome_estacao"
            ? "descend"
            : null,
      title: "Nome Estação",
    },
    {
      key: "ip_estacao",
      dataIndex: "ip_estacao",
      title: "IP Estação",
    },
    {
      key: "data_acesso",
      dataIndex: "data_acesso",
      sorter: true,
      sortOrder:
        ordenacao === "data_acesso"
          ? "ascend"
          : ordenacao === "-data_acesso"
            ? "descend"
            : null,
      title: "Data Acesso",
      render: (value) => formatarData(value),
    },
    {
      key: "bloqueio",
      dataIndex: "bloqueio",
      title: "Bloqueio",
      render: (blocked) => (
        <Tag color={blocked ? "green" : "red"}>{blocked ? "Sim" : "Não"}</Tag>
      ),
    },
    {
      key: "alerta",
      dataIndex: "alerta",
      title: "Alerta",
      render: (alerta) => (
        <Tag color={alerta ? "green" : "red"}>{alerta ? "Sim" : "Não"}</Tag>
      ),
    },
    {
      key: "servidor",
      dataIndex: "servidor",
      title: "Servidor",
      render: (servidor) => (
        <Tag color={servidor ? "green" : "red"}>{servidor ? "Sim" : "Não"}</Tag>
      ),
    },
    {
      key: "chave_liberacao",
      dataIndex: "chave_liberacao",
      title: "Chave de liberação",
    },
    {
      title: "Ações",
      render: (values) => (
        <Space size="middle">
          <Tooltip title="Deletar">
            <DeleteOutlined onClick={() => abrirModalExclusao(values.id)} />
          </Tooltip>

          <Tooltip title="Alerta">
            <AlertOutlined onClick={() => abrirModalAlerta(values)} />
          </Tooltip>

          {values.bloqueio ? (
            <Tooltip title="Bloqueio">
              <LockOutlined onClick={() => abrirModalBloqueio(values)} />
            </Tooltip>
          ) : (
            <Tooltip title="Bloqueio">
              <UnlockOutlined onClick={() => abrirModalBloqueio(values)} />
            </Tooltip>
          )}

          <Tooltip title="Servidor">
            <CloudServerOutlined onClick={() => abrirModalServidor(values)} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const abrirModalExclusao = (id) => {
    setModalExclusaoVisivel(true);
    setEstacaoSelecionadaId(id);
  };

  const buscarEstacoes = async (page, pageSize, id, params) => {
    setCarregandoEstacoes(true);
    try {
      const response = await estacaoRequest.listarEstacoes(page, pageSize, id, {
        ...(params || {}),
        ordering: ordenacao,
      });
      if (response.status === 200 || response.status === 201) {
        const { results, count } = response.data;
        setEstacoes(results);
        setTotalEstacoes(count);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCarregandoEstacoes(false);
    }
  };

  const confirmarControleBloqueio = async () => {
    setConfirmandoControle(true);

    try {
      const response = await estacaoRequest.atualizarBloqueioEstacao(
        { bloqueio: !statusControle },
        estacaoSelecionadaId,
      );

      if (response.status === 200) {
        const { bloqueio } = response.data;

        setMensagemSucesso(
          bloqueio
            ? "Estação bloqueada com sucesso!"
            : "Estação desbloqueada com sucesso!",
        );
        buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
        fecharModalBloqueio();
        setModalSucessoVisivel(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmandoControle(false);
    }
  };

  const confirmarControleAlerta = async () => {
    setConfirmandoControle(true);

    try {
      const response = await estacaoRequest.atualizarAlertaEstacao(
        { alerta: !statusControle },
        estacaoSelecionadaId,
      );

      if (response.status === 200) {
        const { alerta } = response.data;

        setMensagemSucesso(
          alerta
            ? "Alerta ativado com sucesso!"
            : "Alerta desativado com sucesso!",
        );
        buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
        fecharModalAlerta();
        setModalSucessoVisivel(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmandoControle(false);
    }
  };
  const confirmarControleServidor = async () => {
    setConfirmandoControle(true);

    try {
      const response = await estacaoRequest.atualizarServidorEstacao(
        { servidor: !statusControle },
        estacaoSelecionadaId,
      );

      if (response.status === 200) {
        const { servidor } = response.data;

        setMensagemSucesso(
          servidor
            ? "Servidor marcado com sucesso!"
            : "Servidor desmarcado com sucesso!",
        );
        buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
        fecharModalServidor();
        setModalSucessoVisivel(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmandoControle(false);
    }
  };

  const controlarBloqueioEmLote = async (bloqueio) => {
    setProcessandoBloqueioLote(true);

    try {
      const response = await estacaoRequest.atualizarBloqueioEstacoes(id, {
        bloqueio,
      });

      if (response.status === 200) {
        const { bloqueio } = response.data;

        setMensagemSucesso(
          bloqueio
            ? "Estações bloqueadas com sucesso!"
            : "Estações desbloqueadas com sucesso!",
        );
        buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
        setModalBloqueioLoteVisivel(false);
        setModalSucessoVisivel(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProcessandoBloqueioLote(false);
    }
  };

  const abrirModalBloqueio = (controle) => {
    setStatusControle(controle.bloqueio);
    setEstacaoSelecionadaId(controle.id);
    setModalBloqueioVisivel(true);
  };

  const abrirModalAlerta = (controle) => {
    setStatusControle(controle.alerta);
    setEstacaoSelecionadaId(controle.id);
    setModalControleAlertaVisivel(true);
  };

  const abrirModalServidor = (controle) => {
    setStatusControle(controle.servidor);
    setEstacaoSelecionadaId(controle.id);
    setModalControleServidorVisivel(true);
  };

  const fecharModalBloqueio = () => {
    setModalBloqueioVisivel(false);
    setStatusControle(false);
    setEstacaoSelecionadaId(null);
  };
  const fecharModalAlerta = () => {
    setModalControleAlertaVisivel(false);
    setStatusControle(false);
    setEstacaoSelecionadaId(null);
  };
  const fecharModalServidor = () => {
    setModalControleServidorVisivel(false);
    setStatusControle(false);
    setEstacaoSelecionadaId(null);
  };

  const aplicarFiltros = (values) => {
    const filtrosFormatados = {
      ...values,
      data_acesso_inicial: values.data_acesso_inicial
        ? dayjs(values.data_acesso_inicial).startOf("day").toISOString()
        : undefined,
      data_acesso_final: values.data_acesso_final
        ? dayjs(values.data_acesso_final).endOf("day").toISOString()
        : undefined,
    };

    setFiltrosEstacao(filtrosFormatados);
    setPaginaAtual(1);
    setFiltrosVisiveis(false);
  };

  const limparFiltros = () => {
    setFiltrosEstacao({});
    setPaginaAtual(1);
    setFiltrosVisiveis(false);
  };

  const limparFiltro = (filtro) => {
    setFiltrosEstacao((filtrosAtuais) => {
      const filtrosAtualizados = { ...filtrosAtuais };
      delete filtrosAtualizados[filtro];
      return filtrosAtualizados;
    });
    setPaginaAtual(1);
  };

  const atualizarTabela = (pagination, _, sorter) => {
    const colunaOrdenada = Array.isArray(sorter) ? sorter[0] : sorter;
    const proximaPagina = pagination?.current || 1;
    const proximoPageSize = pagination?.pageSize || 10;

    if (proximaPagina !== paginaAtual) {
      setPaginaAtual(proximaPagina);
    }

    if (proximoPageSize !== itensPorPagina) {
      setItensPorPagina(proximoPageSize);
      if (proximaPagina !== 1) {
        setPaginaAtual(1);
      }
    }

    const camposOrdenaveis = ["nome_estacao", "data_acesso"];
    if (!colunaOrdenada?.columnKey) return;
    if (!camposOrdenaveis.includes(colunaOrdenada.columnKey)) return;

    const novaOrdenacao = colunaOrdenada.order
      ? `${colunaOrdenada.order === "descend" ? "-" : ""}${colunaOrdenada.columnKey}`
      : undefined;

    if (novaOrdenacao === ordenacao) return;

    if (proximaPagina !== 1) {
      setPaginaAtual(1);
    }
    setOrdenacao(novaOrdenacao);
  };

  const controlarAlertaEmLote = async (alerta) => {
    setProcessandoAlertaLote(true);

    try {
      const response = await estacaoRequest.atualizarAlertaEstacoes(id, {
        alerta,
      });

      if (response.status === 200) {
        const { alerta } = response.data;

        setMensagemSucesso(
          alerta
            ? "Alertas ativados com sucesso!"
            : "Alertas desativados com sucesso!",
        );

        buscarEstacoes(paginaAtual, itensPorPagina, id, filtrosEstacao);
        setModalAlertaLoteVisivel(false);
        setModalSucessoVisivel(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProcessandoAlertaLote(false);
    }
  };

  return (
    <>
      <Table
        columns={columns}
        dataSource={estacoes}
        loading={carregandoEstacoes}
        onChange={atualizarTabela}
        pagination={{
          current: paginaAtual,
          pageSize: itensPorPagina,
          total: totalEstacoes,
          showTotal: (total) => (
            <span
              style={{ fontWeight: "500", position: "absolute", left: "4%" }}
            >
              Quantidade: {total}
            </span>
          ),
        }}
        title={() => (
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Button
                  icon={<FilterOutlined />}
                  style={{
                    background: colors.secondary,
                    color: "white",
                    fontWeight: "500",
                  }}
                  onClick={() => setFiltrosVisiveis(true)}
                  className="botao"
                >
                  Filtros
                </Button>
                <div style={{ display: "flex", gap: 2 }}>
                  {filtrosEstacao.nome_estacao && (
                    <Tag
                      color="orange"
                      style={{ fontWeight: "500" }}
                      closable
                      onClose={() => limparFiltro("nome_estacao")}
                    >
                      Estação: {filtrosEstacao.nome_estacao}
                    </Tag>
                  )}

                  {filtrosEstacao.data_acesso_inicial && (
                    <Tag
                      color="orange"
                      style={{ fontWeight: "500" }}
                      closable
                      onClose={() => limparFiltro("data_acesso_inicial")}
                    >
                      Acesso Inicial:{" "}
                      {dayjs(filtrosEstacao.data_acesso_inicial).format(
                        "DD/MM/YYYY",
                      )}
                    </Tag>
                  )}

                  {filtrosEstacao.data_acesso_final && (
                    <Tag
                      color="orange"
                      style={{ fontWeight: "500" }}
                      closable
                      onClose={() => limparFiltro("data_acesso_final")}
                    >
                      Acesso Final:{" "}
                      {dayjs(filtrosEstacao.data_acesso_final).format(
                        "DD/MM/YYYY",
                      )}
                    </Tag>
                  )}
                </div>
              </div>

              <div style={{ display: "flex", gap: 8 }}>
                <Button
                  icon={<AlertOutlined />}
                  style={{
                    background: "#FEFCE8",
                    fontWeight: "500",
                    border: "1px solid #FDE68A",
                    color: "#32322e",
                  }}
                  onClick={() => setModalAlertaLoteVisivel(true)}
                >
                  Alerta
                </Button>

                <Button
                  icon={<LockOutlined />}
                  onClick={() => setModalBloqueioLoteVisivel(true)}
                  style={{ fontWeight: "500" }}
                >
                  Bloqueio
                </Button>
              </div>
            </div>
          </div>
        )}
        rowKey="id"
      />

      <FiltrosEstacao
        onClose={() => setFiltrosVisiveis(false)}
        visible={filtrosVisiveis}
        onFinish={(values) => aplicarFiltros(values)}
        onClear={limparFiltros}
      />
      <ModalDelete
        visible={modalExclusaoVisivel}
        onCancel={() => setModalExclusaoVisivel(false)}
        id={estacaoSelecionadaId}
        estadoEstacao={setEstacoes}
      />
      <ModalControle
        onCancel={fecharModalBloqueio}
        onConfirm={confirmarControleBloqueio}
        status={statusControle}
        visible={modalBloqueioVisivel}
        loading={confirmandoControle}
        description={`Deseja ${statusControle ? "desbloquear" : "bloquear"} esta estação?`}
        title="Bloqueio de estação"
      />
      <ModalControle
        onCancel={fecharModalAlerta}
        onConfirm={confirmarControleAlerta}
        status={statusControle}
        visible={modalControleAlertaVisivel}
        loading={confirmandoControle}
        description={`Deseja ${statusControle ? "desativar" : "ativar"} o alerta desta estação?`}
        title="Alerta de estação"
      />
      <ModalControle
        onCancel={fecharModalServidor}
        onConfirm={confirmarControleServidor}
        status={statusControle}
        visible={modalControleServidorVisivel}
        loading={confirmandoControle}
        description={`Deseja ${statusControle ? "desmarcar" : "marcar"} como servidor esta estação?`}
        title="Servidor de estação"
      />

      <ModalStatusControle
        onCancel={() => {
          setModalSucessoVisivel(false);
          setMensagemSucesso(false);
        }}
        visible={modalSucessoVisivel}
        title={mensagemSucesso}
      />

      <ModalControleEstacao
        visible={modalBloqueioLoteVisivel}
        onCancel={() => setModalBloqueioLoteVisivel(false)}
        onSelect={controlarBloqueioEmLote}
        loading={processandoBloqueioLote}
        title="Controle de bloqueio das estações"
        description="Escolha a ação que deseja aplicar para as estações deste cartório."
        primaryAction={{
          label: "Bloquear",
          value: true,
          danger: true,
        }}
        secondaryAction={{
          label: "Desbloquear",
          value: false,
          type: "primary",
        }}
      />
      <ModalControleEstacao
        visible={modalAlertaLoteVisivel}
        onCancel={() => setModalAlertaLoteVisivel(false)}
        onSelect={controlarAlertaEmLote}
        loading={processandoAlertaLote}
        title="Controle de alerta das estações"
        description="Deseja ativar ou desativar o alerta para as estações deste cartório?"
        primaryAction={{
          label: "Ativar",
          value: true,
          type: "primary",
          style: {
            fontWeight: "500",
          },
        }}
        secondaryAction={{
          label: "Desativar",
          value: false,
          type: "primary",
          style: {
            fontWeight: "500",
            background: "#dadde1",
            color: "#2a333f",
            border: "1px solid #7e8896",
          },
        }}
      />
    </>
  );
};
